import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, setToken, formatErr } from "@/lib/api";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-[calc(100vh-64px)] bg-zinc-950 grid place-items-center px-6 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="font-mono text-[11px] tracking-[0.22em] text-zinc-500 hover:text-zinc-300" data-testid="admin-back-home">← Back to vyrtrade.com</Link>
        <div className="mt-6 border border-white/10 bg-zinc-900/60 rounded-lg p-8">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-md border border-white/10 grid place-items-center bg-zinc-950">
              <Lock className="h-4 w-4 text-amber-400" />
            </div>
            <div>
              <div className="font-display text-xl font-semibold">Admin Console</div>
              <div className="text-[12px] text-zinc-500">Authorized personnel only.</div>
            </div>
          </div>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block text-[12px] font-mono tracking-wide text-zinc-400 mb-1.5">Email</label>
              <input
                required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-zinc-950 border border-white/10 focus:border-amber-400/60 focus:outline-none rounded-md px-3.5 py-2.5 text-[14px]"
                placeholder="you@vyrtrade.com" data-testid="admin-email"
              />
            </div>
            <div>
              <label className="block text-[12px] font-mono tracking-wide text-zinc-400 mb-1.5">Password</label>
              <input
                required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-zinc-950 border border-white/10 focus:border-amber-400/60 focus:outline-none rounded-md px-3.5 py-2.5 text-[14px]"
                placeholder="••••••••" data-testid="admin-password"
              />
            </div>
            {error && <div className="text-sm text-red-400" data-testid="admin-login-error">{error}</div>}
            <button
              type="submit" disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-blue-600 hover:bg-blue-500 text-white text-sm font-medium disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
